import { AxiosError } from "axios";
import { createContext, ReactNode, useContext } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { openModel } from "../reducers/error.slice";

interface ErrorContextValue {
  handleErrorAction: (error: Error) => void;
}
const ErrorContext = createContext<ErrorContextValue | undefined>(undefined);

function ErrorContextProvider({ children }: { children: ReactNode }) {
  const dispatch = useDispatch();
  const handleErrorAction = (error: Error) => {
    if (error instanceof AxiosError) {
      if (error.response?.status === 500) {
        if (error.response.data instanceof ArrayBuffer) {
          error.response.data = JSON.parse(
            new TextDecoder().decode(error.response.data),
          );
        }
        if (error.response?.data?.apiexceptionresponse?.refId === null) {
          toast.error(
            <p
              dangerouslySetInnerHTML={{
                __html: error.response?.data?.apiexceptionresponse?.message,
              }}
            ></p>,
          );
        }

        if (error.response?.data?.apiexceptionresponse?.refId !== null) {
          const errorMessage =
            error.response?.data?.apiexceptionresponse?.message;
          toast.error(
            <span>
              {errorMessage}{" "}
              <span
                onClick={() =>
                  dispatch(
                    openModel({
                      refId: error.response?.data?.apiexceptionresponse?.refId,
                    }),
                  )
                }
                style={{ textDecoration: "underline", cursor: "pointer" }}
              >
                Report Error
              </span>
            </span>,
          );
        }
      }
      return;
    }
  };
  return (
    <ErrorContext.Provider value={{ handleErrorAction }}>
      {children}
    </ErrorContext.Provider>
  );
}

function useError() {
  const context = useContext(ErrorContext);
  if (context === undefined)
    throw new Error("ErrorContext was used outside of ErrorContextProvider");
  return context;
}

export { ErrorContextProvider, useError };
